import { graphql } from "gql.tada";

export const MetadataFragment = graphql(`
  fragment MetadataFragment on PageMetadata {
    title
    description
    indexPage
  }
`);
